// import _get from 'lodash.get';

const getFormat = (data = []) => {
    let result = {};
    let banner = [];
    let brands = [];
    let category = [];

    data.home_screen.forEach(item => {
        if (item.type === 1 && banner.length === 0) {
            banner = item.data.banners;
        } else if (item.type === 2 && brands.length === 0) {
            brands = item.data.brands;
        } else if(item.type === 4 && category.length === 0) {
            category = item.data.category;
        }
    })

    banner.sort(function(a, b) {
        return a.sequence - b.sequence;
    });

    brands.sort(function(a, b) {
        return a.sequence - b.sequence;
    });

    category.sort(function(a, b) {
        return a.sequence - b.sequence;
    });

    result = {
        banner: banner,
        brands: brands,
        category: category,
    }

    return result;
}

const getProductsByBrand = (data = []) => {
    if(data.collections) {
        data.collections?.sort(function(a, b) {
            return a.sequence - b.sequence;
        });
    }

    return data;
}

export const getFormattedProductCustomizationObj = (customizationObj) => {
	const { is_back_calculate_tax , store_prices, price, tax_category } = customizationObj;
	const priceToShow = store_prices?.[0]?.price || price;
	
	return {
		...customizationObj,
		name:customizationObj.name,
		id:customizationObj.id,
		customisation_id:customizationObj.id,
		price: parseFloat(priceToShow),
		is_back_calculate_tax,
		tax_category,
        is_default: customizationObj.default
	}
}
const getProductCustomization = (data = []) => {
    let result = []; 
    if(data.child_customization_groups && data.child_customization_groups.length>0) { 
        result = data.child_customization_groups.sort(function(a, b) {
            return a.sequence - b.sequence;
        });
        result.customisations_groups = data.child_customization_groups.map(group=>{
            let product_group = []
            let customisation_products = group?.products ? group?.products : group?.customisations
            customisation_products?.forEach(product=>{
                product.group_id = group.id;
                product_group.push(getFormattedProductCustomizationObj(product))
            })
            group.customisations = product_group;
        })
    }else{
        result = data.customisations_groups?.sort(function(a, b) {
            return a.sequence - b.sequence;
        });
        result.customisations_groups = data.customisations_groups
    }

    return result;
}

const getProductDetails = (data = []) => {
    return data;
}

const getComboDetails = (data = []) => {
    return data.sets;
}

export const productsParser = {
    getFormat,
    getProductsByBrand,
    getProductCustomization,
    getProductDetails,
    getComboDetails,
}
